import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d8f4dcfa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "menu"
};
const _hoisted_2 = {
  class: "wrapper",
  id: "wrapper",
  ref: "test"
};
const _hoisted_3 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goods, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "good-item",
      key: item.name
    }, _toDisplayString(item.name), 1);
  }), 128))])], 512)]);
}